import * as React from 'react';
import { Fragment } from 'react';
import { Header } from '../components/header';
import { reportRequest, OEEHistory, DATA_REFRESH_TIME } from '../api/dataTypes';
import "react-datepicker/dist/react-datepicker.css";
import { PromiseHelper } from '../classes/promiseHelper';
import { OEERecordsTable } from '../components/table-oeeRecords';
import { getOEEApi } from '../api/api-cutRecords';
import { OEESummary } from '../components/oeeSummaryComponent';
import { DataSelectionHeader } from '../components/dataSelectionHeader';
import moment from 'moment';
import { STORAGE } from '../api/api-account';

interface State {
    oeeRecordsData: OEEHistory[] | null;
    reportRequest: reportRequest;
    message: string;
    setupTime: number;
}

export interface Props { }

export class OEEPage extends React.Component<Props, State> {
    recordsPromise: PromiseHelper<OEEHistory[]> = new PromiseHelper();
    dataTimerId: number | null = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            oeeRecordsData: null,
            reportRequest: {
                startDate: moment(new Date(Date.now()))
                    .subtract(7, "days")
                    .toDate(),
                endDate: new Date(Date.now()),
                systemId: 0,
                org: 0,
                shiftStartTime: moment(localStorage.getItem(STORAGE.SHIFT_START)! || moment().hour(23).minute(55)).toDate(),
                shiftEndTime: moment(localStorage.getItem(STORAGE.SHIFT_END)! || moment().hour(23).minute(55)).toDate() 
            },
            setupTime: parseInt(localStorage.getItem(STORAGE.SETUP_TIME)!, 10) || 0,
            message: 'loading...'
        }
    }

    componentWillUnmount() {
        this.recordsPromise.clearPromise();
        if (this.dataTimerId !== null) {
            window.clearInterval(this.dataTimerId);
            this.dataTimerId = null;
        }        
    }

    componentDidMount=()=>{
        this.getRecords(this.state.reportRequest);
        this.dataTimerId = window.setInterval(this.getRecords, DATA_REFRESH_TIME);
    }

    render() {
        return (
            <Fragment>
                <Header />
                <div className="d-flex header-page-title ">
                    <div className="m-2 ml-3 mr-auto">
                        Utilization Records
                    </div>
                </div>
                <DataSelectionHeader
                    getRecords={this.getRecords}
                    showShifts={true}
                    enableOwnerSelection={false}
                />
                {/* TODO: Grouping: Day, week, month? Currently per day */}

                <div className="row page-standard">
                    <div className="col-5 right-divider">
                        <OEESummary
                            records={this.state.oeeRecordsData}
                            startDate={this.state.reportRequest.startDate}
                            endDate={this.state.reportRequest.endDate}
                        />
                    </div>
                    <div className="col-7">
                        <OEERecordsTable
                            records={this.state.oeeRecordsData}
                            loading={this.state.oeeRecordsData === null}
                        />
                        <div className='justify-content-center component-standard'>
                            <div className={`input-group mb-2 `}>
                                <div className="input-group-prepend">
                                    <span className='input-group-text input-label-wide' >
                                        Adjust Setup Time per Cut (min): 
                                    </span>
                                </div>
                                <input 
                                    type={"number"}
                                    className="col-2 form-control"
                                    placeholder={String(this.state.setupTime)}
                                    value={String(this.state.setupTime) || ''}
                                    name={'setupTime'}
                                    onChange={e => this.handleSetupTimeChange(e)}
                                /> 
                                <button
                                    className="btn button-standard ml-4"
                                    onClick={() => this.getRecords(this.state.reportRequest)}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }

    handleSetupTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let val: number = parseInt(e.target.value, 10);
        localStorage.setItem(STORAGE.SETUP_TIME, e.target.value);
        this.setState(prevState => ({
            ...prevState,
            setupTime: val
        }));
    }

    private getRecords = (request: reportRequest | null) => {
        this.recordsPromise!.newPromise(
            getOEEApi(request || this.state.reportRequest, this.state.setupTime),
            result => {
                this.setState({
                    oeeRecordsData: result,
                    reportRequest: request || this.state.reportRequest,
                    message: ''
                });
            },
            e => {
                console.log(`Error caught in page-oee.getRecords(). ${e.message} ${e.detail}`);
                alert('Error getting OEE records');
            }
        );
    }
}